<template>
  <div id="app">
    <CardLogin
      class="full-width"
    />
  </div>
</template>

<script>
import CardLogin from './components/CardLogin';

export default {
  components: {
    CardLogin,
  },
};
</script>

<style lang="scss" scoped>
  .full-width {
    width: 100%;
  }
</style>
